import { testId } from '../../utils';
import * as Switch from '@radix-ui/react-switch';
import React, { forwardRef } from 'react';

export interface ToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  'data-testid': string;
}

export const Toggle = forwardRef<HTMLButtonElement, ToggleProps>(
  ({ checked, onCheckedChange, 'data-testid': dataTestId }, ref) => {
    return (
      <Switch.Root
        {...testId(dataTestId)}
        ref={ref}
        className="relative h-[32px] w-[52px] bg-gray cursor-default rounded-full outline-1 focus:shadow-black data-[state=checked]:bg-blue-active"
        onCheckedChange={onCheckedChange}
        checked={checked}
      >
        <Switch.Thumb
          {...testId(dataTestId, 'thumb')}
          className="block size-[24px] data-[state=checked]:border-blue-active border-gray border-solid border translate-x-0.5 rounded-full bg-white transition-transform duration-100 will-change-transform data-[state=checked]:translate-x-[24px]"
        />
      </Switch.Root>
    );
  },
);
Toggle.displayName = 'Toggle';
